/**
 * @Author proudlx
 * @Description http请求的默认配置文件
 */
const defaultTimeout = 30 * 1e3;
const uploadTimeout = 10 * 60 * 1e3;
const networkErrorMsg = "网络异常，请重试！(错误码:x{0}) ";

const configMap: any = {
  default: {
    baseURL:
      process.env.NODE_ENV === "development"
        ? "/chxt" // 本地要代理的地址
        : (location.origin.indexOf('tiktokforbusiness-learning-center.com') > -1? 'https://www.tiktokforbusiness-learning-center.com/chxt_api' :process.env.VUE_APP_BASE_API),
    headers: {
      "Content-Type": "application/json;charset=UTF-8",
      Accept: "application/json;charset=UTF-8",
    },
    // application/x-www-form-urlencoded; charset=UTF-8
    timeout: defaultTimeout,
    withCredentials: true,
  },
  // 后端接口多服务配置
  fileDefault: {
    baseURL:
      process.env.NODE_ENV === "development"
        ? "/fileApi"
        : process.env.VUE_APP_UPDATA_API,
    headers: {
      "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      Accept: "application/json;charset=UTF-8",
    },
    timeout: uploadTimeout,
    withCredentials: true,
  },
  download: {
    responseType: "blob",
  },
  fileheader: {
    headers: {
      post: { "Content-Type": "multipart/form-data;" },
    },
  },
};
const successCode = [0, '00', 200];

export { successCode, configMap, networkErrorMsg };
